import { SNAPSHOT } from '../config/snapshot';

export const getSnapshotProposalUrl = (proposalId: string) => {
  return `https://snapshot.org/#/${SNAPSHOT.space}/proposal/${proposalId}`;
};
